import { ReachMenuComponent } from '../main/main-menu.directive';

export const openMenuWithResult = async (
	menu: ReachMenuComponent | undefined,
	getResult: () => boolean
): Promise<boolean> => {
	if (!menu) {
		return false;
	}

	return await new Promise<boolean>((resolve) => {
		const sub = menu.closed$$.subscribe(() => {
			sub.unsubscribe();
			resolve(getResult());
		});
		menu.open();
	});
};
